// extracted by mini-css-extract-plugin
module.exports = {"form":"TaskAddForm_form__2d1ou"};